import React from "react";

import { isLinkedSettlement } from "../../../utils";
import { AccountCompositionProps } from "./types";
import { ValueComposition } from "./ValueComposition";

// The one place the account-shaped defaults live: three call sites passing the same seven props
// were free to drift on which absent figure becomes zero and which stays null.
export const AccountComposition: React.FC<AccountCompositionProps> = ({
  investment,
}) => (
  <ValueComposition
    trackingMode={investment.trackingMode}
    invested={investment.investedValue}
    gain={investment.netGain}
    withdrawn={investment.withdrawnValue}
    currentValue={investment.brokerValue ?? 0}
    cashBalance={investment.cashBalance ?? null}
    securitiesValue={investment.securitiesValue ?? null}
    showsCash={!isLinkedSettlement(investment)}
  />
);
